<template>
  <div>
    <div class="panel">
      <div class="panel__header">
        <div class="panel__header__left panel__header-width-m">
          <!-- <div class="search-form width-100">
          <span class="search hidden--xs">
            <span class="search__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path fill="#919EAB" fill-rule="evenodd" d="M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8m9.707 4.293l-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414"/>
                </svg>
            </span>
            <span class="search__input">
                <input type="text" class="form__input" placeholder="Search transfers">
            </span>
          </span>
          </div>-->
          <div class="panel__header__left"><b>{{ name }}</b> &nbsp; Funding History</div>
        </div>
        <div class="panel__header__right">
          <div class="filter__options">
            <button
              class="btn btn--default btn--flex"
              data-toggle="modal"
              data-target="#createFilteredModal"
            >
              <span class="btn__icon">
                <svg
                  class
                  enable-background="new 0 0 971.986 971.986"
                  version="1.1"
                  viewBox="0 0 971.986 971.986"
                  xml:space="preserve"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#576ae6"
                    d="m370.22 459.3c10.2 11.1 15.8 25.6 15.8 40.6v442c0 26.601 32.1 40.101 51.1 21.4l123.3-141.3c16.5-19.8 25.6-29.601 25.6-49.2v-272.8c0-15 5.7-29.5 15.8-40.601l353.8-383.9c26.5-28.8 6.101-75.5-33.1-75.5h-873c-39.2 0-59.7 46.6-33.1 75.5l353.8 383.8z"
                  ></path>
                </svg>
              </span>
              <span class="btn__text">Add filter</span>
            </button>
          </div>
          <div class="filter__options" style="padding-left: 15px;">
            <button class="btn btn--default" @click="handleWalletFundingHistory(1)" id="DownloadFile">
              Download
            </button>
          </div>
          <div class="contact-trigger">
            <router-link :to="{name:'fund-wallet'}" class="btn btn--primary btn--flex">+ Fund Wallet</router-link>
          </div>
          <!-- <a class="btn btn--default btn--schedule" title="schedule payment" data-toggle="modal" data-target="#schedulePaymentModal">
            OPEN
          </a>-->
        </div>
      </div>
      <div class="panel__content panel__content--grey outer-container">
        <div
          class="table__section table__section--head"
          data-toggle="modal"
          data-target="#createFilteredModal"
        >
          Showing
          <span class="pointer">{{message}}</span>
        </div>
        <div class="loaderContainer" v-if="isLoading">
          <img src="/static/wave.gif" alt width="32" height="32">
        </div>

        <transition name="slide-fade" v-if="!fundingListEmpty">
          <div class="table">
            <!-- Table body -->
            <div
              class="table__section table__section--body"
              v-for="transaction in walletTransactions.data"
            >
              <!-- table row -->
              <div class="table__row">
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--bold">
                    <small class="table__data--result">{{transaction.shortCode}}</small>
                    <br>
                    {{ transaction.amount | numeralize('0,0.00') }}
                  </div>
                </div>
                <!-- table data -->
                <div class="table__data">
                  Source
                  <br>
                  <span class="table__data--result">{{transaction.source}}</span>
                </div>
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--default">{{ createdAgo(transaction.createdAt) }}</div>
                  <div class="table__data--sub">{{ momentDate(transaction.createdAt) }}</div>
                </div>

                <!-- table data -->
                <div class="table__data">
                  Reference
                  <br>
                  <div class="table__data--sub">{{transaction.ref}}</div>
                </div>

                <!-- table data -->
                <div class="table__data">
                  <div class="tag" :class="['tag--' + transaction.status]">{{transaction.status}}</div>
                </div>
              </div>
              <div class="table__row spacer"></div>
            </div>
          </div>
        </transition>

        <div class="panel__empty" v-if="fundingListEmpty">
          <div class="panel__empty__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="92" height="70" viewBox="0 0 92 70">
              <g fill="none" fill-rule="evenodd" transform="translate(-1 -1)">
                <rect
                  width="43"
                  height="60"
                  x="10"
                  y="6"
                  fill="#D6DBEB"
                  opacity=".269"
                  rx="3"
                  transform="rotate(-22 31.5 36)"
                ></rect>
                <rect
                  width="43"
                  height="60"
                  x="41"
                  y="6"
                  fill="#D6DBEB"
                  opacity=".269"
                  rx="3"
                  transform="rotate(22 62.5 36)"
                ></rect>
                <g fill-rule="nonzero">
                  <g transform="translate(47 45)">
                    <path
                      fill="#4B536B"
                      d="M10.968.279a5.039 5.039 0 1 0 .001 10.077A5.039 5.039 0 0 0 10.968.28zm2.178 7.326c-.134.27-.32.495-.562.676a2.561 2.561 0 0 1-.859.408c-.13.037-.266.064-.404.086v.591h-.775v-.542a4.194 4.194 0 0 1-.562-.05 3.82 3.82 0 0 1-.569-.134 2.764 2.764 0 0 1-.418-.164 1.021 1.021 0 0 1-.244-.156.474.474 0 0 1-.118-.23 1.924 1.924 0 0 1-.042-.465c0-.135.004-.243.014-.324a.776.776 0 0 1 .042-.195c.019-.049.042-.082.069-.098a.21.21 0 0 1 .105-.024c.052 0 .127.029.227.087.101.058.225.122.374.191.149.071.322.135.52.195s.422.091.673.091c.159 0 .299-.015.422-.048s.23-.079.321-.14a.593.593 0 0 0 .207-.23.702.702 0 0 0 .069-.321.535.535 0 0 0-.128-.359 1.128 1.128 0 0 0-.343-.262 3.983 3.983 0 0 0-.481-.209 11.381 11.381 0 0 1-.552-.217 5.015 5.015 0 0 1-.55-.272 2.077 2.077 0 0 1-.482-.377 1.694 1.694 0 0 1-.341-.538 1.956 1.956 0 0 1-.13-.753c0-.297.058-.571.175-.82.116-.248.283-.461.503-.639.218-.176.485-.314.799-.412.14-.043.288-.077.443-.101v-.582h.775v.54a4.14 4.14 0 0 1 .907.143c.149.042.275.088.377.136.102.049.176.091.22.126a.315.315 0 0 1 .093.105.454.454 0 0 1 .043.126 2.556 2.556 0 0 1 .034.449c0 .126-.003.228-.01.307a.779.779 0 0 1-.035.189c-.016.045-.038.077-.065.093a.193.193 0 0 1-.098.025.484.484 0 0 1-.195-.073 3.307 3.307 0 0 0-.331-.157 4.035 4.035 0 0 0-.461-.157 2.205 2.205 0 0 0-.596-.073c-.159 0-.296.016-.412.049a.773.773 0 0 0-.286.14.61.61 0 0 0-.225.474c0 .145.044.266.134.363.088.098.204.184.349.258.144.076.307.145.491.21.184.064.37.136.558.213.189.077.375.166.559.268.183.102.348.228.491.377.145.149.261.327.349.534.088.207.132.452.132.736a2.148 2.148 0 0 1-.201.936z"
                    ></path>
                    <circle cx="2.34" cy="5.317" r="1.679" fill="#D6DBEB"></circle>
                    <circle cx="19.596" cy="5.317" r="1.679" fill="#D6DBEB"></circle>
                  </g>
                  <path
                    fill="#4B536B"
                    d="M72.194 41.635H43.742c-.785 0-1.421.563-1.421 1.257v14.852c0 .694.636 1.257 1.421 1.257h28.451c.785 0 1.421-.563 1.421-1.257V42.892c.001-.695-.635-1.257-1.42-1.257zM44.59 54.338v-7.357c.987-.009 3.28-.352 3.286-3.34h20.221c.017.994.381 3.197 3.25 3.247v7.377c-.963.036-2.84.409-3.122 2.729h-20.32c-.164-1.108-.837-2.65-3.315-2.656z"
                  ></path>
                  <g fill="#4B536B">
                    <path
                      d="M35.6 25.5h4.466v4.466H35.6zM43.615 25.5h4.466v4.466h-4.466zM51.631 25.5h4.466v4.466h-4.466zM27.584 32.291h4.466v4.466h-4.466zM27.584 25.5h4.466v4.466h-4.466zM35.6 32.291h4.466v4.466H35.6zM43.615 32.291h4.466v4.466h-4.466zM51.631 32.291h4.466v4.466h-4.466zM27.584 39.081h4.466v4.466h-4.466zM39.724 42.892c0-.553.123-1.079.342-1.554v-2.256H35.6v4.466h4.124v-.656z"
                    ></path>
                    <g>
                      <path
                        d="M31.147 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.669 1.488-1.488 1.488zM41.873 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.669 1.488-1.488 1.488zM52.599 15.249h-.065c-.818 0-1.488-.67-1.488-1.488v-3.273c0-.818.67-1.488 1.488-1.488h.065c.818 0 1.488.67 1.488 1.488v3.273c0 .818-.67 1.488-1.488 1.488z"
                      ></path>
                      <path
                        d="M57.022 12.124h-1.079v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636h-3.974v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636h-3.974v1.636c0 1.844-1.5 3.343-3.343 3.343h-.065a3.347 3.347 0 0 1-3.343-3.343v-1.636H26.66c-4.563 0-8.274 3.712-8.274 8.274v20.375c0 4.563 3.712 8.274 8.274 8.274h13.064v-3.711H26.66a4.568 4.568 0 0 1-4.563-4.563V23.435h39.489v15.602h3.711V20.399c-.001-4.563-3.712-8.275-8.275-8.275z"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="panel__empty__text">
            Funding list empty.
            <router-link :to="{name:'fund-wallet'}" class="link">Fund</router-link>your wallet
            Or change your
            <span class="link pointer" data-toggle="modal" data-target="#createFilteredModal">filter</span>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="schedulePaymentModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="schedulePaymentModal"
      >
        <!-- Modal Dialog -->
        <div class="modal__dialog modal__dialog--xlg" role="document">
          <!-- Modal content -->
          <div class="modal__content">
            <div class="modal__header">
              <div class="modal__title">
                <span class="time-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Capa_1"
                    x="0px"
                    y="0px"
                    width="512px"
                    height="512px"
                    viewBox="0 0 612 612"
                    style="enable-background:new 0 0 612 612;"
                    xml:space="preserve"
                    class="icon--sm"
                  >
                    <g>
                      <g>
                        <g>
                          <path
                            d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#576ae6"
                            fill="#576ae6"
                          ></path>
                          <path
                            d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                            data-original="#000000"
                            class="active-path"
                            data-old_color="#576ae6"
                            fill="#576ae6"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </span>
                Modal Open
              </div>
              <!-- Modal close button -->
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                  <path
                    fill="#C0C6D8"
                    fill-rule="nonzero"
                    d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z"
                  ></path>
                </svg>
              </button>
            </div>
            <!-- Modal Body -->
            <div class="modal__body modal__body--pad">
              <div class="disburse__confirmation">
                <div class="disburse__confirmation__breakdown">
                  <!--amount disbursed-->
                  <div class="breakdown__item">
                    <div class="breakdown__item__name">Payment amount</div>
                    <div class="breakdown__item__result">$ 12,348,232</div>
                  </div>
                </div>
                <div class="disbursement__schedule"></div>
                <!--confirm disbursement-->
                <div class="disburse__confirmation__submit">
                  <button class="btn btn--primary btn--block">RUN ACTION</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--pagination-->
    <transition name="slide-fade">
      <pagination
        :paginationProp="paginationProp"
        v-if="!paginationProp.paginationEmpty"
        :key="paginationProp.pagination.total"
      ></pagination>
    </transition>

    <div
      class="modal fade"
      id="createFilteredModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createFilteredModal"
    >
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--xsf" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <!-- Modal Body -->
          <div class="modal__body">
            <div class>
              <form action class="form form__padf" @submit.prevent="handleWalletFundingHistory()">
                <div class="form__item">
                  <datepicker
                    :inputClass="'form__input input'"
                    required="required"
                    :placeholder="'Date Start'"
                    @selected="formatStartDate"
                    :value="search.createdAt.from"
                  ></datepicker>
                </div>
                <div class="form__item">
                  <datepicker
                    :inputClass="'form__input input'"
                    required="required"
                    :placeholder="'Date End'"
                    @selected="formatEndDate"
                    :value="search.createdAt.to"
                  ></datepicker>
                </div>
                <div class="form__item">
                  <input
                    type="text"
                    name="reference"
                    placeholder="Reference"
                    v-model="search.flutterReference"
                    id="walletName"
                    class="form__input input"
                    data-vv-id="1"
                    aria-required="true"
                    aria-invalid="false"
                  >
                </div>
                <div class="form__item">
                  <select
                    name="status"
                    class="select__input select__input--md"
                    v-model="search.status"
                  >
                    <option value>Select a Status</option>
                    <option value="completed">Completed</option>
                    <option value="Failed">Failed</option>
                    <option value="pending">pending</option>
                  </select>
                  <div class="select__icon select__icon--in-pagination">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="6"
                      height="10"
                      viewBox="0 0 6 10"
                    >
                      <path
                        fill="#42476f"
                        fill-rule="evenodd"
                        d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                      ></path>
                    </svg>
                  </div>
                </div>

                <br>
                <br>

                <div class="form__item">
                  <button
                    id="fundWallet"
                    type="submit"
                    class="btn btn--primary btn--block beneficiary_submit"
                    @click="filter()"
                    data-dismis="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#createFilteredModal"
                  >Create Filter</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationView from "@/components/partials/PaginationView";
import { getWalletTransactions } from "../../utils/wallet-transactions/walletService";
import ta from "time-ago";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  created() {
    this.handleWalletFundingHistory(); // Fetches posts when the component is created.
  },

  beforeRouteUpdate(to, from, next) {
    this.$Progress.start();
    this.handleWalletFundingHistory();
    this.$Progress.finish();
    // don't forget to call next()
    next();
  },

  data() {
    return {
      name: '',
      search: {
        createdAt: {
          from: "",
          to: ""
        },
        flutterReference: "",
        status: ""
      },
      isLoading: true,
      showModal: false,
      selected: "All",
      options: {},
      singleFundingErrors: [],
      count: "",
      fundingListEmpty: false,
      message: "",
      download: 0,
      itemPerPage: "",
      walletTransactions: [],
      paginationProp: {
        pagination: {},
        paginationEmpty: true,
        pathName: ""
      }
    };
  },

  components: {
    pagination: PaginationView,
    Datepicker
  },

  watch: {
    // call again the fetch method if the route changes
    $route: "handleWalletFundingHistory"
  },

  methods: {
    momentDate(date) {
        return moment(date).format('MMM DD, YYYY')
    },
    createdAgo(time) {
      return ta.ago(time);
    },
    formatDateRange(start, end) {
      const startD = moment(start).format("D");
      const endD = moment(end).format("D");
      const startMn = moment(start).format("MM");
      const endMn = moment(end).format("MM");
      const startYr = moment(start).format("YY");
      const endYr = moment(end).format("YY");
      let d = "";

      if (startD === endD && startMn === endMn && startYr === endYr) {
        d = `${startD} ${moment(end).format("MMMM")} ${endYr}`;
      } else if (startMn === endMn && startYr === endYr) {
        d = `${startD} -
      ${moment(end).format("D")} ${moment(end).format(
          "MMMM"
        )} ${endYr}`;
      } else if (startYr === endYr) {
        d = `${startD} ${moment(start).format("MMM")} -
      ${moment(end).format("D")} ${moment(end).format(
          "MMM"
        )} ${endYr}`;
      } else {
        d = `${startD} ${moment(start).format("MMM")} ${startYr} -
      ${moment(end).format("D")} ${moment(end).format(
          "MMM"
        )} ${endYr}`;
      }

      return d;
    },
    formatStartDate (date) {
      this.search.createdAt.from = moment(date).format().toString().split('T')[0];
    },

    formatEndDate (date) {
      this.search.createdAt.to = moment(date).format().toString().split('T')[0];
    },
    filter() {
      let data = {};
      if (this.search.createdAt.from == null) {
        this.search.createdAt.from = "";
      }
      if (this.search.createdAt.to == null) {
        this.search.createdAt.to = "";
      }
      data = this.search;
      this.$store.commit("updateWalletFundingSearch", data);
      // location.reload();
    },
    handleWalletFundingHistory(download = 0) {
      this.download = download;
      let data2 = {};
      if (window.localStorage.getItem("WalletFundingSearch") == null) {
        this.search.createdAt.from = moment()
          .startOf("month")
          .format().toString().split('T')[0];
        this.search.createdAt.to = moment().format().toString().split('T')[0];
        data2 = this.search;
        this.$store.commit("updateWalletFundingSearch", data2);
      }
      data2 = JSON.parse(window.localStorage.getItem("WalletFundingSearch"));
      this.search = JSON.parse(
        window.localStorage.getItem("WalletFundingSearch")
      );
      this.message = "all wallet funding history ";
      let walletarray = window.localStorage.getItem('walletList');
      Object.keys(JSON.parse(walletarray)).forEach((rep) => {
        if(JSON.parse(walletarray)[rep].currencyId === this.$route.params.id) this.name = JSON.parse(walletarray)[rep].name.toUpperCase();
      });
      this.$Progress.start();
      getWalletTransactions(
        this.$route.params.id,
        this.$route.query.per_page,
        this.$route.query.page,
        "wallet-fund",
        "funding",
        data2,
        this.download
      ) //call imported function from reportsService; pass page number and data limit
        .then(response => {
          if (response.data.data) {
            this.isLoading = false;
            this.fundingListEmpty = false;
            this.$Progress.finish();
            if (this.search["flutterReference"] !== "") {
              this.message += "• " + this.search["flutterReference"] + " ";
            }
            if (this.search.status !== "") {
              this.message += "• " + this.search.status + " ";
            }
            let date = this.formatDateRange(
              this.search["createdAt"]["from"],
              this.search["createdAt"]["to"]
            );
            this.message += "• " + date;

            if (
              Object.keys(response.data.data).length === 0 &&
              typeof response.data.data === "object"
            ) {
              this.fundingListEmpty = true;
            } else {
              this.walletTransactions = response.data;
            }
            if (response.data.meta.pagination.total > 0) {
              this.paginationProp.pagination = response.data.meta.pagination;
              this.paginationProp.paginationEmpty = false;
              this.paginationProp.pathName = this.$route.name;
            } else {
              this.paginationProp.paginationEmpty = true;
            }
          } else if (response.data.file) {
            this.$Progress.finish();
            if (response.data.file.includes('staging')) {
              this.downloadFile(`https://staging.moneywaveapp.com/admin/v1/file/${response.data.file.split('file/')[1]}`);
            } else {
              this.downloadFile(`https://frontend.moneywaveapp.com/admin/v1/file/${response.data.file.split('file/')[1]}`);
            }
          }
        })

        .catch(e => {
          this.$Progress.fail();
          this.singleFundingErrors.push(e);
        });
    },
    downloadFile(text){
        window.open(text, "_blank");
    },
  },
  computed: {
    numberOfPages() {
      return Math.ceil(parseInt(this.count) / parseInt(this.itemPerPage));
    }
  }
};
</script>

<style lang="css">
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/wallet/SingleBalanceFundings.vue